<template>
  <div>
    <section class="tables">
      <b-container>
        <b-row>
          <b-col cols="4">Name</b-col>
          <b-col cols="8">
            {{ modalData.firstName }} {{ modalData.lastName }}
          </b-col>

          <b-col cols="4">Email</b-col>
          <b-col cols="8">{{ modalData.email || "-" }}</b-col>

          <b-col cols="4">Phone</b-col>
          <b-col cols="8">{{ modalData.phone || "-" }}</b-col>

          <b-col cols="4">PNR No</b-col>
          <b-col cols="8">{{ modalData.pnr_no }}</b-col>

          <b-col cols="4">Reason</b-col>
          <b-col cols="8">{{ modalData.reason }}</b-col>

          <b-col cols="4">Days of Leave</b-col>
          <b-col cols="8">{{ modalData.days_of_leave }}</b-col>

          <b-col cols="4">Refund Dates</b-col>
          <b-col cols="8">
            <ul class="mb-0">
              <li v-for="(d, i) in modalData.refund_dates" :key="i">
                {{ d }}
              </li>
            </ul>
          </b-col>

          <b-col cols="4">Total Refund</b-col>
          <b-col cols="8">₹ {{ modalData.totalRefund }}</b-col>

          <b-col cols="4">Status</b-col>
          <b-col cols="8">
            <b-badge
              :variant="modalData.status === 'Approved' ? 'success' :
                        modalData.status === 'Rejected' ? 'danger' : 'warning'"
            >
              {{ modalData.status }}
            </b-badge>
          </b-col>

          <b-col cols="4">Requested At</b-col>
          <b-col cols="8">{{ modalData.createdAt }}</b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "RefundView",
  props: {
    modalData: {
      type: Object,
      required: true
    }
  }
};
</script>
